import React, { useEffect, useState, useRef, useCallback } from "react";
import MetaTags from "react-meta-tags";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Mdatatable from "components/Datatables/Mdatatables";
import Notifications from "components/Notifications";
import DeleteConfirmationModel from "components/delete-confirmation-model";
import { getCode, userModuleData } from 'helpers/basic_helper';
import { get } from 'helpers/api_helper';
import { PRODUCT_OPTIONS_URL, PRODUCT_URL } from "helpers/url_helper";
import { useDispatch, useSelector } from 'react-redux';
import { addRecord, getAllRows, getAllRowsSuccess, productOptions } from 'store/actions';
import FormComponent from "../Masters/FormComponent";
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";
import { getBasePermissions } from "modules/Utility/getPermission";
import { runBatchLoader } from "utils/batchLoader";

const isType = 'Product'
const Product = props => {
    const module = getBasePermissions('product_master');
    const canAdd = module?.isAdmin || Boolean(module?.menu?.product_master?.products?.add);
    const canEdit = module?.isAdmin || Boolean(module?.menu?.product_master?.products?.edit);
    const canDelete = module?.isAdmin || Boolean(module?.menu?.product_master?.products?.delete);
    const dispatch = useDispatch()
    const { loading, products, DDProduct } = useSelector(state => state.Master);
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState(false)
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isEdit, setIsEdit] = useState(false)
    const [DDCategories, setDDCategories] = useState(false)
    const [DDWarranty, setDDWarranty] = useState(false)
    const [DDTypes, setDDTypes] = useState(false)
    const [DDGroups, setDDGroups] = useState(false)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [error, setError] = useState(false);
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })
    const [batchProgress, setBatchProgress] = useState(null)
    const batchCancelRef = useRef(false)
    const isBatchRunningRef = useRef(false)
    const totalRowsRef = useRef(0)

    useEffect(() => {
        const count = products?.total_rows || dataRows?.total_rows
        if (count) {
            totalRowsRef.current = count
        }
    }, [products, dataRows])

    const handleCancelBatch = () => {
        batchCancelRef.current = true
        isBatchRunningRef.current = false
        setBatchProgress(prev => prev ? ({ ...prev, active: false, stopped: true }) : null)
        setIsLoading(false)
    }

    const handlePaginationChange = useCallback((newPag) => {
        setPagination(prev => {
            if (
                prev.page === newPag.page &&
                prev.limit === newPag.limit &&
                prev.search === newPag.search &&
                Boolean(prev.isAll) === Boolean(newPag.isAll)
            ) {
                return prev
            }
            return { ...prev, ...newPag }
        })
    }, [])
    
    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);

    const getData = async() => {
        const isAllSelected = pagination?.isAll || pagination?.limit === 'all' || (typeof pagination?.limit === 'number' && pagination?.limit > 100);

        if (!DDProduct || DDProduct.length === 0) {
            dispatch(productOptions({url:PRODUCT_OPTIONS_URL}));
        }

        if (isAllSelected) {
            batchCancelRef.current = true
            await new Promise(r => setTimeout(r, 60))
            batchCancelRef.current = false
            isBatchRunningRef.current = true

            setIsLoading(true)
            try {
                await runBatchLoader({
                    fetchPage: async (page, batchSize) => {
                        const res = await get(`${PRODUCT_URL}?page=${page}&limit=${batchSize}&search=${pagination?.search || ''}`);
                        return res?.response || res || {};
                    },
                    batchSize: 250,
                    initialTotal: totalRowsRef.current || 0,
                    onProgress: setBatchProgress,
                    onRowsLoaded: (accumulatedRows, totalCount) => {
                        const payload = {
                            total_rows: totalCount,
                            rows: accumulatedRows
                        };
                        setDataRows(payload);
                        dispatch(getAllRowsSuccess({ isEdit: false, data: payload, isType: isType }));
                    },
                    cancelRef: batchCancelRef,
                    runningRef: isBatchRunningRef,
                });
            } catch (err) {
                console.error("Error batch loading products:", err);
            } finally {
                setIsLoading(false);
            }
        } else {
            setDataRows([]);
            setIsLoading(true);
            setBatchProgress(null);
            dispatch(getAllRows({url:`${PRODUCT_URL}?page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, isSingle: false, isType: isType}, props.history));
        }
    }

    useEffect(() => {
        setDataRows(products)
        if (products && (products.rows || Array.isArray(products))) {
            setIsLoading(false)
        }
    }, [products, loading])
    
    useEffect(() => {
        setDDCategories(DDProduct?.category?.map( v => ({label: v.title, value: v.code})))
        setDDGroups(DDProduct?.group?.map( v => ({label: v.title, value: v.code})))
        setDDWarranty(DDProduct?.warranty?.map( v => ({label: v.title, value: v.code})))
        setDDTypes(DDProduct?.producttype?.map( v => ({label: v.title, value: v.code})))
    } ,[DDProduct])
    
    // Open RightSide Panel
    const submitForm = (e, data) => {
        const checkCode = dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.code).toUpperCase())
        if(data?.id =='' && checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        const addupdate_callback = () => {
            getData()
            isOpen(false)
            Notifications('You have successfully added a Product.!')
        }

        if(data.selectedValue){
            Object.keys(data.selectedValue)?.map( v => {
                data[v] = data.selectedValue[v].value
            })
        }

        const Obj = {
            "id": data.id ? data.id : '',
            "title": data.title,
            "code": data.code,
            "legancy_code":"",
            "desc":"",
            "group":data?.group || "",
            "brand": data?.brand || "",
            "warranty":data.warranty,
            "category":data.category,
            "type":data.type,
            "unit_price":data.unit_price
        }
        dispatch(addRecord({isType:isType, Obj:Obj, url: PRODUCT_URL+`${data?.target?.id?.value ? '?q='+data?.target?.id?.value : '' }`, id: data?.target?.id?.value}, props.history, addupdate_callback))
    }
    
    // Update Data , Get Singlw ROw using url params ?q=?
    const handleEdit = data => {
        const cb = (data) => {
            setEditableObj(data)
            setIsLoading(false)
            isOpen(true)
        }
    
        if (data > 0) {
            setEditableObj({ id: data })
            setIsLoading(true)
            dispatch(getAllRows({url:`${PRODUCT_URL}?q=${data}`, isSingle: true}, props.history, cb))
        }
    }

    // Remove Data
    const handleRemove = (q, status, code) => {
        if(q > 0){
            setIsDeleteModel({url: PRODUCT_URL, q, status, code, isMaster: false})
        }
    }

    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }
    
    const loadProductTypes = () => {}

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        }, {
            dataField: 'title',
            text: 'Product'
        },{
            dataField: 'code',
            text: 'Product Code',
            formatter: (cell, row) => <b>{row.code}</b>,
        },{
            dataField: 'unit_price',
            text: 'Product Price',
            formatter: (cell, row) => <b>Rs.{row.unit_price}</b>,
        },{
            dataField: 'acategory',
            text: 'Product Category'
        },{
            dataField: 'awarranty',
            text: 'Product Warranty'
        },{
            dataField: 'atype',
            text: 'Product Type'
        }
    ];

    const showActionColumn = canEdit || canDelete;

    if(showActionColumn){
        datatableData = [...datatableData, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => {
                if (!canEdit && !canDelete) return null;

                return (
                <>
                    {canEdit && (
                    <Link
                        to="#"
                        className="btn btn-outline-secondary btn-sm edit"
                        onClick={() => handleEdit(row.id)}
                        title="Edit"
                    >
                        <i className="fas fa-pencil-alt" />
                    </Link>
                    )}

                    {canDelete && (
                    <Link
                        to="#"
                        className="ms-1 btn btn-outline-danger btn-sm edit"
                        onClick={() => handleRemove(row.id, row.status, row.code)}
                        title="Delete"
                    >
                        <i className="fas fa-trash-alt" />
                    </Link>
                    )}
                </>
                );
            },
        }]
    }

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj?editableObj.id : '',
            col:12
        },{
            name: "title",
            label: "Product Name",
            placeholder: "Please Enter Product Name",
            required: true,
            type: 'text',
            value: editableObj?editableObj.title : '',
            col:12
        },{
            name: "code",
            label: "Product Code",
            placeholder: "Please Enter Product Code",
            required: true,
            type: 'text',
            value: editableObj?editableObj.code:getCode("products", dataRows?.total_rows),
            col: 6
        },{
            name: "unit_price",
            label: "Product Unit Price",
            placeholder: "Please Enter Product Unit Price",
            required: true,
            type: 'text',
            value: editableObj?editableObj.unit_price : '',
            col:6
        },{
            name: "category",
            label: "Product Category",
            placeholder: "Please Select Product Category",
            required: true,
            type: 'select',
            isMulti: false,
            options: DDCategories,
            callback: loadProductTypes,
            value: editableObj? DDCategories?.filter( v => v.value == editableObj.category) : '',
            col:6
        // },{
        //     name: "group",
        //     label: "Product Group",
        //     placeholder: "Please Enter Product Group",
        //     required: false,
        //     type: 'select',
        //     isMulti: false,
        //     options: DDGroups,
        //     value: editableObj? DDGroups?.filter( v => v.value == editableObj.group) : '',
        //     col:6
        // },{
        //     name: "brand",
        //     label: "Product Brand",
        //     placeholder: "Please Select Product Brand",
        //     required: false,
        //     type: 'select',
        //     options: DDProduct?.brand?.map( v => ({label: v.title, value: v.code})),
        //     value: editableObj? DDProduct?.brand?.filter( v => v.code = editableObj.brand).map( v => ({label: v.title, value: v.id})) : '',
        //     col:6
        },{
            name: "warranty",
            label: "Product Warranty",
            placeholder: "Please Select Product Warranty",
            required: false,
            isMulti: false,
            type: 'select',
            options: DDWarranty,
            value: editableObj? DDWarranty?.filter( v => v.value == editableObj.warranty) : '',
            col:6
        },{
            name: "type",
            label: "Product Type",
            placeholder: "Please Select Product Type",
            required: false,
            isMulti: false,
            type: 'select',
            options: DDTypes,
            value: editableObj? DDTypes?.filter( v => v.value == editableObj.type) : '',
            col:6
        }
        /* ,{
            name: "legancy_code",
            label: "Legancy Code",
            placeholder: "Please Enter Legancy Code",
            required: false,
            type: 'text',
            value: editableObj?editableObj.legancy_code : '',
            col:6
        },{
            name: "desc",
            label: "Description",
            placeholder: "Please Enter Description",
            required: true,
            type: 'text',
            value: editableObj?editableObj.type : '',
            col:6
        } */
            // },{
        //     name: "title",
        //     label: "Offer",
        //     placeholder: "Please Enter Offer Code",
        //     required: false,
        //     type: 'text',
        //     value: editableObj?editableObj.offer : '',
        //     col:6
        // }
    ]

    
    useEffect(async() => {
        const data =  await userModuleData('product_master', 'products')
        setIsActions(data)
        if(data && (data?.edit || data?.delete)){
            setIsActionColumn(true)
        }
    }, [])


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags> <title>Dashboard | {isType}</title> </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Masters" breadcrumbItem={"Products"} />
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={true}
                                        columns = {datatableData}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.total_rows || products?.total_rows || (Array.isArray(products) ? products.length : (Array.isArray(dataRows) ? dataRows.length : 0))}
                                        rows = {dataRows?.rows || (Array.isArray(dataRows) && dataRows.length > 0 ? dataRows : null) || products?.rows || (Array.isArray(products) ? products : []) || []}
                                        keyField={'id'}
                                        handleAddButton={()=>{
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}            
                                        title = "All Products"
                                        loading={(loading || isLoading) && (!batchProgress || batchProgress.loaded === 0)}
                                        batchProgress={batchProgress}
                                        onCancelBatch={handleCancelBatch}
                                        isAdd = {canAdd}
                                        isTableHead = {true}
                                        ssr={handlePaginationChange}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            {/* End Datatable */}
            {
                open &&
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} Product`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={loading}
                    editableObj={editableObj}
                    onDrawerClose={() => {
                        setEditableObj(null)
                        isOpen(!open)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}

            { isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} /> }
        </React.Fragment>
    )
}

export default Product
